import React from "react";
import {
  AEAutoComplete,
  AEInput,
} from "../../../../../../_metronic/_partials/controls";
import { useIntl } from "react-intl";

const Create = ({
  coins,

  _props,

  paymentMethod,
}) => {
  const { formatMessage } = useIntl()
  const MAD1 = formatMessage({ id: "BANK.AMOUNT.MAD1" });
  const MAD2 = formatMessage({ id: "BANK.AMOUNT.MAD2" });
  return (
    <>
      <div className="form-group row py-1">
        <div className={"col-lg-12"}>
          <AEInput {..._props("coins", "WALLET.COINS")} />
          {/* <label htmlFor="">Coins</label> */}
          {/* <input
            type="number"
            className="form-control mb-4"
            onChange={(e) => handleCoinsChange(e.target.value)}
            value={coins}
          /> */}
          <label>{formatMessage({ id: "BANK.AMOUNT" })}</label>
          <input
            type="text"
            className="form-control py-1"
            disabled
            value={`${coins} ${coins <= 10 ? MAD2 : MAD1}`}
          />
          {/* {paymentMethod === "bank_transfer" && (
            <small style={{ color: "red" }}>
              {formatMessage({ id: "AMOUNT_FEE" })}
            </small>
          )} */}
        </div>
      </div>
      <div className="form-group row py-1">
        <AEAutoComplete
          {..._props("payment_method", "PAYMENT_METHOD", "autocomplete")}
          options={[
            { id: "bank_transfer", label: "PAYMENT_METHOD.BANK_TRANSFER" },
            { id: "cash", label: "PAYMENT_METHOD.CASH" },
            { id: "voucher", label: "PAYMENT_METHOD.VOUCHER" },
            // { id: "credit_card", label: "PAYMENT_METHOD.ONLINE_PAYMENT" },
          ]}
          getOptionLabel={o => o.label ? formatMessage({ id: o?.label }) : o}

        />
      </div>
    </>
  );
};

export default Create;
